import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FBF_PRAEFIXE, FbfPraefix } from './fbf-praefixe';

/**
 * Hilfe zum Vorsatz (Praefix) einer Feinbodenform.
 *
 * Vorher stand hier ein Textblock mit der nackten Buchstabenreihe und der
 * Ueberschrift „FBFPrefix" — man sah, was erlaubt ist, aber nicht, was es heisst.
 * Jetzt: eine Tabelle Kuerzel → Bedeutung aus [FBF_PRAEFIXE](fbf-praefixe.ts).
 */
@Component({
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Erlaubte Präfixe</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<p class="einleitung">
				Der Präfix steht vor der Feinbodenform und sagt, wie der Oberboden verändert wurde.
				Er wird je Bodenglied einzeln gesetzt.
			</p>

			<table class="table table-sm praefix-tabelle">
				<thead>
					<tr>
						<th class="code-spalte">Kürzel</th>
						<th>Bedeutung</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let p of praefixe">
						<td class="code-spalte"><code>{{ p.code }}</code></td>
						<td [class.offen]="p.unsicher">{{ bedeutung(p) }}</td>
					</tr>
				</tbody>
			</table>

			<p class="hinweis">
				Mehrere Kürzel lassen sich hintereinander schreiben, zum Beispiel
				<code>bp</code> oder <code>tpb</code>.
				<br />
				<code>Ap</code> ist das einzige Kürzel mit großem Anfangsbuchstaben;
				<code>ap</code> wird nicht angenommen.
			</p>

			<p class="quelle" *ngIf="hatOffene">
				Mit <span class="offen">?</span> markierte Bedeutungen sind noch nicht gesichert und werden nachgetragen.
			</p>
			<p class="quelle">Bedeutungen überwiegend nach SEA 95, Teil A, Abschnitt 8.10 „Veränderungen des Oberbodens", S. 237</p>
		</div>
	`,
	styles: [`
		.modal-body {
			padding: 1rem 1.5rem;
		}
		.einleitung {
			margin-bottom: 1rem;
		}
		.praefix-tabelle {
			margin-bottom: 1rem;
		}
		.praefix-tabelle th {
			background: #f8f9fa;
			font-weight: 600;
		}
		.praefix-tabelle td,
		.praefix-tabelle th {
			vertical-align: middle;
		}
		.code-spalte {
			width: 5.5rem;
			white-space: nowrap;
		}
		.praefix-tabelle code {
			font-size: 1rem;
			color: #212529;
			background: #f1f3f5;
			border-radius: 3px;
			padding: 0.1rem 0.4rem;
		}
		.offen {
			color: #6c757d;
		}
		.hinweis {
			margin-bottom: 0.75rem;
		}
		.hinweis code {
			color: #212529;
			background: #f1f3f5;
			border-radius: 3px;
			padding: 0.05rem 0.3rem;
		}
		.quelle {
			font-size: 0.82rem;
			color: #6c757d;
			margin-bottom: 0;
		}
	`]
})
export class FbfPraefixInfoModalComponent {
	activeModal = inject(NgbActiveModal);

	praefixe = FBF_PRAEFIXE;

	hatOffene = FBF_PRAEFIXE.some(p => p.unsicher);

	/** Ohne gesicherten Klartext steht ein Fragezeichen da — nicht geraten. */
	bedeutung(p: FbfPraefix): string {
		if (!p.bedeutung) return '?';
		return p.unsicher ? `${p.bedeutung} (?)` : p.bedeutung;
	}
}
